import React from "react";
import faqs from "../../Assets/images/home/faq.png";
import fyf from "../../Assets/images/home/fund.png";
import { motion } from "framer-motion";
import {
  motionVariantsLeft,
  motionVariantsRight,
  motionProperties,
} from "../../Components/Common/MotionVarients";
import { useNavigate } from "react-router-dom";

const faqItems = [
  {
    img: fyf,
    alt: "find your Course",
    title: "Find Our Courses",
    description:
      "The choices you make in the early stages of your career are crucial. Understand your options and get advice from those invested in your future.",
    motionVariant: motionVariantsLeft,
    path: "/courses",
  },
  {
    img: faqs,
    alt: "frequently asked questions",
    title: "Frequently Asked Questions",
    description:
      "Find answers to some of the most common questions our applicants ask. We want all of our students to be fully informed about what we do and how our programs operate.",
    motionVariant: motionVariantsRight,
    path: "/faqs",
  },
];

const FAQs = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="w-full h-auto bg-gray-100 overflow-hidden">
        <div className="grid lg:grid-cols-2 grid-cols-1 md:gap-4 gap-4 justify-center py-20 mx-auto max-w-7xl px-6 lg:px-8">
          {faqItems.map((item, index) => (
            <div key={index} className="p-10 bg-white rounded-md shadow">
              <div className="grid md:grid-cols-2 grid-cols-1 lg:items-end md:items-center">
                <div>
                  <h1 className="md:text-4xl text-2xl font-bold lg:w-[50%] ">
                    {item?.title}
                  </h1>
                </div>
                <div>
                  <img
                    src={item?.img}
                    alt={item?.title}
                    className="w-auto h-[200px]"
                  />
                </div>
              </div>
              <p className="mt-2 text-secondaryTextColor line-clamp-3">
                {item?.description}
              </p>
              <button
                onClick={() => navigate(item?.path)}
                className="bg-primaryOrangeColor hover:bg-primaryDarkColor text-white rounded px-4 py-2 mt-2"
              >
                Explore More
              </button>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default FAQs;
